import {
  Accordion,
  Attribute,
  CustomMobileAccordionType,
  DataTable,
  DataTableColumn,
  FormatterType,
  GameInfo,
  Icon,
  Section,
  StatsGameFormatter,
} from "best-common-react";
import React, { useCallback, useEffect, useState } from "react";
import { getAllDayOfTickets } from "../../../api/RequesTixApi";
import { AdminDayOfTicket } from "../../../types/TodaysTickets";
import DeleteTodayTicketModal from "./DeleteTodayTicketModal";

const AdminActiveTodaysTicketsTable = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [tickets, setTickets] = useState<AdminDayOfTicket[]>([]);
  const [selectedTicket, setSelectedTicket] = useState<AdminDayOfTicket | undefined>(undefined);

  const DeleteFormatter = ({ row, className }: FormatterType<AdminDayOfTicket>) => (
    <Icon iconName="fa-trash-alt" onClick={() => setSelectedTicket(row)} className={className} />
  );

  const AdminDayOfTicketAccordion = ({
    data,
    ...rest
  }: CustomMobileAccordionType<AdminDayOfTicket> & { children?: React.ReactNode }) => {
    const { game, gamePk, ticketId, seat, row, section } = data as AdminDayOfTicket;
    return (
      <Accordion {...rest}>
        <Accordion.Header>
          <div className="d-flex">
            <GameInfo
              gameDate={game.gameDate}
              venue={game.venue}
              home={game.teams.home.team}
              away={game.teams.away.team}
              seriesDescription={game.seriesDescription}
            />
          </div>
        </Accordion.Header>
        <Accordion.Body>
          <div>
            <div className="d-flex justify-content-end">
              <DeleteFormatter value={seat} row={data} className="fa-lg" />
            </div>

            <Attribute header="GamePk:" value={gamePk} horizontal headerWidth={120} />
            <Attribute header="Ticket ID:" value={ticketId} horizontal headerWidth={120} />
            <Attribute header="Section:" value={section} horizontal headerWidth={120} />
            <Attribute header="Row:" value={row} horizontal headerWidth={120} />
            <Attribute header="Seat:" value={seat} horizontal headerWidth={120} />
          </div>
        </Accordion.Body>
      </Accordion>
    );
  };

  const Cols: DataTableColumn<AdminDayOfTicket>[] = [
    { key: "seat", name: "", width: 35, readonlyFormatter: DeleteFormatter, icon: "fa-trash-alt", fixed: true },
    { key: "game", name: "Game", width: 400, readonlyFormatter: StatsGameFormatter, fixed: true },
    { key: "gamePk", name: "Game PK", minWidth: 200 },
    { key: "ticketId", name: "Ticket ID", minWidth: 300 },
    { key: "section", name: "Section", minWidth: 150 },
    { key: "row", name: "Row", width: 150 },
    { key: "seat", name: "Seat", minWidth: 150 },
  ];

  const getAllTickets = useCallback(async () => {
    try {
      setLoading(true);
      const result: AdminDayOfTicket[] = await getAllDayOfTickets();
      setTickets(result);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void getAllTickets();
  }, [getAllTickets]);

  return (
    <div>
      <Section
        sectionKey="current-todays-tickets"
        header={`Current Today's Tickets (${tickets.length})`}
        className="bcr-mb-2"
      >
        <DeleteTodayTicketModal
          selectedTicket={selectedTicket}
          setSelectedTicket={setSelectedTicket}
          refresh={getAllTickets}
        />
        <DataTable
          data={tickets}
          columns={Cols}
          loading={loading}
          statusTextOverride={(_selected, total) => `${total} Today's Tickets`}
          accordion={AdminDayOfTicketAccordion}
          tableHeights={{
            maxTableHeight: 600,
            minTableHeight: 300,
            autogrow: true,
          }}
        />
      </Section>
    </div>
  );
};

export default AdminActiveTodaysTicketsTable;
